import React, { useState } from 'react';
import "./newsdiv.css";


function NewsDiv(props) {

  
const [background,setBackground] = useState(true)
  return (
    <div className='newsdiv'
 ><div className="news">&#187;{ props.title }   &#171;</div>
      <div className="desc">  by &nbsp; <span className="by"> { props.author ||"snotat"}   </span>. &nbsp; <h4> 1 &nbsp;</h4> posts & <h4> &nbsp; {Math.floor(Math.random()*2000)} &nbsp; </h4> views. {props.time}</div>
      
    </div>
  )
}

export default NewsDiv